import { subduedColor, contrastColor } from 'styles/styleVariables'
import type { PackageInfo } from 'types'

const processPackage = (ndc?: string, packages?: PackageInfo[]): PackageInfo | undefined => {
  if (!packages || !packages.length || !ndc) return

  const filteredPackage = packages.filter(pkg => pkg.ndc === ndc)

  return filteredPackage.length ? filteredPackage[0] : packages[0]
}

const getStatusColor = (itemStatusFlag: string): string => {
  if (itemStatusFlag === 'A' || itemStatusFlag === 'I') {
    return contrastColor
  }
  return subduedColor
}

export { processPackage, getStatusColor }
